import Page, { getInitialProps } from '@lib/page';

export const config = { unstable_runtimeJS: true }
export default function Callback(props: any){
	return Page(props)
}

Callback.getInitialProps = (props: any) =>{
	return getInitialProps({ ...props, load: true })
}
